import * as React from 'react';
import { CollectionShort } from '../../../types/Collection';
import getCollection from '../../../requests/getCollection';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import Book from '../../Book/Book';
import { useParams, useHistory } from 'react-router-dom';
import './Collection.css';
import cn from 'classnames';
import Button from '../../Button/Button';
import { CardsManagerCallbacks } from '../../CardsManager/CardsManager';
import Control from './Control/Control';
import Avatar from '@material-ui/core/Avatar';

interface Props {
	callbacks: CardsManagerCallbacks;
}

const Collection: React.FC<Props> = props => {
	const params = useParams<{id: string}>(),
		collectionId = parseInt(params.id);
	
	const history = useHistory();

	const [isLoading, setLoading] = React.useState(false);
	const [collection, setCollection] = React.useState<CollectionShort>(null);

	const Request = async () => {
		const data = await getCollection(collectionId);

		setCollection(data);
		setLoading(false);
	};

	React.useEffect(() => {
		setLoading(true);

		Request();
	}, [collectionId]);

	return <div className={cn({'collection_loading': isLoading})}>
		{isLoading && <CircularProgress />}
		
		{!isLoading && collection && <div>
			<div className="collection__block">
				<div className="collection__header" style={{backgroundImage: `url(${collection.image})`}}>
					<div className="collection__name">
						{collection.name}
					</div>

					<div className="collection__desc">
						{collection.description}
					</div>
				</div>

				{collection.user && <div className="collection__user">
					<Avatar src={collection.user.image} />
					
					{`${collection.user.firstName} ${collection.user.lastName}`}
				</div>}

				<div className="collection__books">
					{collection.books.map(book => {
						return <Book
							type="standart"
							disabled={true}
							key={book.id}
							book={book}
							payload={
								<>
									<div className="collection__books__desc">
										{book.description}
									</div>

									<div className="collection__books__control">
										<Control
											book={book}
											callbacks={props.callbacks}
										/>
									</div>
								</>
							}
						/>
					})}
				</div>
			</div>
		</div>}
	</div>;
};

export default Collection;
